import React, {useEffect} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {PageWrapperContent} from 'presentation/components';
import {FeaturesEnum, HomeEnum} from 'presentation/constants';
import {useServicePermission} from 'presentation/hooks/useServicePermission';
import {useContractStatus} from 'presentation/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {useOperationalCostStore} from 'presentation/hooks/useOperationalCostPassword/store';
import {useAccountInformation} from '../hooks';

export function MyReferralsWrapper() {
	const {canOpenService, serviceTypeByPath} = useServicePermission();
	const {healthOdonto, healthOnly, isResponsibleWithoutBenefits} = useAccountInformation();
	const {pathname} = useLocation();
	const isOperationalCostAuthorizated = useOperationalCostStore(
		state => state.isOperationalCostAuthorized,
	);
	const serviceType = serviceTypeByPath(pathname);
	const {isValid, isContractSuspended} = useContractStatus();

	const {isEnabled: isMyReferralsFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_MEUS_ENCAMINHAMENTOS,
	);

	const canAccessMyReferralsService =
		isValid &&
		!isContractSuspended &&
		!isResponsibleWithoutBenefits &&
		isMyReferralsFeatureFlagEnabled &&
		(healthOdonto || healthOnly);

	useEffect(() => {
		if (!canAccessMyReferralsService) return;
		if (!isOperationalCostAuthorizated) {
			canOpenService(serviceType);
		}
	}, [pathname, isOperationalCostAuthorizated]);

	if (!canAccessMyReferralsService) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return <PageWrapperContent />;
}
